<template>
   <b-container fluid>
     <router-view></router-view>
   </b-container>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style>
</style>
